import { RequestAbortSignal } from '@/Enums/ChangeLogHistory/RequestAbortSignal.enum';
import { useRequestSaver } from '@/hooks/RequestSaver';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectChangeLogHistoryData } from '@/store/selectors/changeLogHistory.selectors';
import { selectSharedApiLoading } from '@/store/selectors/sharedApi.selectors';
import {
  getCampaignOptions,
  getLogHistory,
  resetChangeLogHistoryPageState,
} from '@/store/slices/changeLogHistory.slice';
import { getClients, getWhitelabels } from '@/store/slices/sharedApi.slice';
import { Card } from '@mui/material';
import { useEffect } from 'react';
import ChangeLogHistoryGrid from './ChangeLogHistoryGrid';

const ChangeLogHistory = () => {
  const dispatch = useAppDispatch();

  const { data, loading, filters, total } = useAppSelector(selectChangeLogHistoryData);
  const sharedApiLoading = useAppSelector(selectSharedApiLoading);
  const requestSaver = useRequestSaver();

  useEffect(() => {
    dispatch(getClients());
    dispatch(getWhitelabels());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getLogHistory({ ...requestSaver.requestSaverSetCancellation(RequestAbortSignal.ChangeLogHistory) }));
  }, [dispatch, filters]);

  useEffect(() => {
    if (sharedApiLoading) return;
    dispatch(getCampaignOptions({ ...requestSaver.requestSaverSetCancellation(RequestAbortSignal.CampaignOptions) }));
  }, [dispatch, filters.advertisers, sharedApiLoading]);

  useEffect(() => {
    return () => {
      requestSaver.requestSaverAbortAll();
      dispatch(resetChangeLogHistoryPageState());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className='w-full p-[30px]'>
      <Card className='h-full'>
        <ChangeLogHistoryGrid data={data} loading={loading} rowCount={total} />
      </Card>
    </div>
  );
};

export default ChangeLogHistory;
